import {TableCell, styled} from '@mui/material'

const StyledTableData = styled(TableCell)(() => ({
    fontSize: { md: '14px', xl: '16px' },
    padding: "10px"
}));

export default StyledTableData